import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const jobNoteService = {
  getNotes: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}/notes`);
    return response.data;
  },
  addNote: async (jobId, note) => {
    const response = await api.post(`/jobs/${jobId}/notes`, { note });
    return response.data;
  },
  deleteNote: async (noteId) => {
    const response = await api.delete(`/job-notes/${noteId}`);
    return response.data;
  },
  updateNote: async (noteId, note) => {
    const response = await api.put(`/job-notes/${noteId}`, { note });
    return response.data;
  },
};
